module.exports = __webpack_public_path__ + "img/document.9b98bb87.svg";